import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CrmResyncWarningDialogComponent } from './crm-resync-warning-dialog.component';

@Injectable()
export class CrmResyncWarningDialogService {
  constructor(private readonly matDialog: MatDialog) {
  }

  openWarningDialog(): Observable<boolean> {
    return this.matDialog.open(CrmResyncWarningDialogComponent, {
      width: '600px',
    }).afterClosed();
  }
}
